import React from "react";

import CardRehabExamination from "react-lib/apps/HISV3/RHB/CardRehabExamination";

type CardRehabExaminationPlanProps = {
  onEvent: any;
  setProp: any;
  controller: any;
  django: any;
  currentDoctor: any;
  rehabExamPlan: any;
  rehabExamPlanList: any[];
  buttonLoadCheck: any;
  errorMessage: any;
  languageUX: string;
  masterOptions: any;
  searchedItemListWithKey: any;
  selectedEncounter: any;
};

const CardRehabExaminationPlan = (props: CardRehabExaminationPlanProps) => {
  console.log("CardRehabExam props.controller :", props.controller);

  return (
    <CardRehabExamination
      onEvent={props.onEvent}
      setProp={props.setProp}
      controller={props.controller}
      django={props.django}
      currentDoctor={props.currentDoctor}
      rehabExamPlan={props.rehabExamPlan}
      rehabExamPlanList={props.rehabExamPlanList}
      buttonLoadCheck={props.buttonLoadCheck}
      errorMessage={props.errorMessage}
      languageUX={props.languageUX}
      masterOptions={props.masterOptions}
      searchedItemListWithKey={props.searchedItemListWithKey}
      selectedEncounter={props.selectedEncounter}
    />
  );
};

CardRehabExaminationPlan.displayName = "CardRehabExaminationPlan";

export default React.memo(CardRehabExaminationPlan);
